(function ($) {

    $(document).ready(function () {

        $(".section_slider_section_type_1 .slick-slider").slick({
            infinite: true,
            dots: false,
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false,
            speed: 500,
            cssEase: "linear",
            autoplaySpeed: 6000,
            prevArrow: '<button type="button" class="slick-prev"></button>',
            nextArrow: '<button type="button" class="slick-next"></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }

            ]
        });

    });

})(jQuery);